import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  sessionManagementSurface: {
    padding: "10px 0 10px 0",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "100%",
  },
  title: {
    marginBottom: "5px",
  },
  sessionOption: {
    marginBottom: "5px",
  },
  addingSessionButton: {
    marginTop: "2px",
    alignSelf: "flex-end",
  },
  dropDownButton: {
    marginTop: "2px",
    marginBottom: "8px",
    marginRight: "2px",
    width: "100%",
  },
  dropDownButtonNav: {
    marginTop: "0px",
    marginBottom: "0px",
    marginRight: "8px",
    minWidth: "200px",
    border: "none",
    backgroundColor: "transparent",
  },
  listboxSize: {
    maxHeight: "200px",
    overflowY: "auto",
  },
  loadSessionButton: {
    width: "50px",
    alignSelf: "flex-end",
  },
  selectionOptions: {
    display: "flex",
    flexDirection: "column",
  },
  textFormatting: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  sessionButtons: {
    height: "20px",
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "10px",
  },
  toastLevel: {
    zIndex: 1000,
    height: "0px",
    position: "absolute",
  },
  optionsChildrenSpacing: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    gap: "4px",
  },
});
